// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"edb67b3f","595":"aaca2236"}[chunkId] + ".chunk.js";
};